<div class="paytm-wrapper">
  <span class="pay-via">Scan here to pay with Paytm Wallet</span>
  <span class="paytm-icon" data-bg="../assets/images/wallets.png?w=auto"></span>
  <img *ngIf="qrCodeUrl" [hidden]="!qrCodeUrl" [src]="'data:image/png;base64,'+qrCodeUrl" width="120" alt="qr code">
  <div *ngIf="!qrCodeUrl" class="linear-background"></div>
  <div *ngIf="paymentUtilService.utmProceedClicked">
    <app-utm-wallet-hundred type="payment" [donation]="cartDetails?.donated_amount"></app-utm-wallet-hundred>
  </div>
</div>
